<template>
  <div
    v-if="
      globals.isAccessAllowed('LoopOp_Agencies_ReadAll') &&
      !globals.isLocalAgencyUser
    "
  >
    <div>
      <agency-management-toolbar
        ref="agencyManagementToolbar"
        :table-element-count="tableElementCount"
        :agencySelected="agencySelected"
        :refreshEnabled="refreshEnabled"
        @searchTextChanged="onSearchTextChanged"
        @pageSizeChanged="onPageSizeChanged"
        @pageNumberChanged="onPageNumberChanged"
        @openEditAgency="toggleModal"
        @openDeleteAgency="showDeleteModal = true"
        @onTriggerReload="triggerReload"
        @hook:mounted="readComponentSettingsFromStore"
      ></agency-management-toolbar>
    </div>
    <div class="panel panel-default">
      <div class="panel-body">
        <agency-management-table
          ref="agencyManagementTable"
          :table-filter="tableFilter"
          :page-size="pageSize"
          :page-number="pageNumer"
          :selectedAgency="selectedAgency"
          @onTableElementsCountChange="onTableElementsCountChange"
          @onAgencySelected="onAgencySelected"
          @onAgencyOpenEdit="onAgencyOpenEdit"
          @onRefreshEnabled="onRefreshEnabled"
          @agenciesReceived="agencyList = $event"
        ></agency-management-table>
      </div>
    </div>
    <agency-management-edit-modal
      :show-edit-modal="showEditModal"
      :mode-add="modeAdd"
      :edit-agency-model="selectedAgency"
      :allRegions="allRegions"
      :agencyList="agencyList"
      @modalClosed="onModalClosed"
      @onAgencySaved="onAgencySaved"
    ></agency-management-edit-modal>

    <confirmation-dialog
      :confirmationTitle="lang.AM0000"
      :yesButtonText="lang.AM0002"
      :noButtonText="lang.AM0003"
      :showDialog="showDeleteModal"
      :colorRed="true"
      @onYesConfirmation="onAgencyDeleted"
      @dialogClosed="showDeleteModal = false"
    >
      <p>
        <b>{{ lang.AM0001 }}</b>
      </p>
      <div class="form-group">
        <label class="col-md-3 text-black">{{ lang.AM0004 }}</label>
        <label class="col-md-9 text-black">{{ selectedAgency.AgencyId }}</label>
      </div>
      <div class="form-group">
        <label class="col-md-3 text-black">{{ lang.AM0005 }}</label>
        <label class="col-md-9 text-black">
          {{ selectedAgency.AgencyName }}
        </label>
      </div>
      <div class="form-group">
        <label class="col-md-3 text-black">{{ lang.AM0006 }}</label>
        <label class="col-md-9 text-black">
          {{ selectedAgency.AgencySince }}
        </label>
      </div>
    </confirmation-dialog>
  </div>
</template>

<script>
import AgencyManagementToolbar from "./AgencyManagementToolbar";
import AgencyManagementTable from "./AgencyManagementTable";
import AgencyManagementEditModal from "./AgencyManagementEditModal";
import ConfirmationDialog from "../Tools/Dialogs/ConfirmationDialog";

export default {
  name: "AgencyManagement",
  created() {
    this.globals.getRegionsList((callbackData) => {
      this.allRegions = callbackData;
    });
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    this.globals.getAgencyTypeList((data) => {
      this.agencyTypeList = data;
    });
  },
  beforeDestroy() {
    this.writeComponentSettingsToStore();
  },
  data() {
    return {
      showEditModal: false,
      showDeleteModal: false,
      tableFilter: "",
      tableElementCount: 0,
      pageSize: 20,
      pageNumer: 0,
      selectedAgency: {},
      agencySelected: false,
      modeAdd: null,
      allRegions: [],
      agencyTypeList: [],
      agencyList: [],
      refreshEnabled: false,
      lang: {
        AM0000: "Agentur löschen",
        AM0001: "Soll folgende Agentur wirklich gelöscht werden?",
        AM0002: "Ja",
        AM0003: "Nein",
        AM0004: "ID",
        AM0005: "Name",
        AM0006: "Agentur seit",
      },
    };
  },
  methods: {
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      let storedData = this.$store.getters["localFilters/agencyManagement"];
      if (storedData) {
        if (storedData.searchString)
          this.$refs["agencyManagementToolbar"].searchString = _.cloneDeep(
            storedData.searchString
          );
        if (storedData.pageSize)
          this.$refs["agencyManagementToolbar"].pageSize = _.cloneDeep(
            storedData.pageSize
          );
        if (storedData.currentSort)
          this.$refs["agencyManagementTable"].currentSort = _.cloneDeep(
            storedData.currentSort
          );
        this.$refs["agencyManagementToolbar"].emitUserSearch();
        this.$refs["agencyManagementToolbar"].emitChangePageSize();
      }
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      if (
        this.$refs["agencyManagementToolbar"] &&
        this.$refs["agencyManagementTable"]
      ) {
        this.$store.commit("localFilters/agencyManagement", {
          searchString: this.$refs["agencyManagementToolbar"].searchString,
          currentSort: this.$refs["agencyManagementTable"].currentSort,
          pageSize: this.$refs["agencyManagementToolbar"].pageSize,
        });
      }
    },
    toggleModal(modeAdd) {
      this.modeAdd = modeAdd;
      if (modeAdd) {
        this.selectedAgency = {};
        this.agencySelected = false;
      }
      this.showEditModal = !this.showEditModal;
    },
    // Emits from toolbar
    onSearchTextChanged(value) {
      this.tableFilter = value;
    },
    onPageSizeChanged(value) {
      this.pageSize = value;
    },
    onPageNumberChanged(value) {
      this.pageNumer = value - 1;
    },
    triggerReload() {
      if (this.$refs.agencyManagementTable)
        this.$refs.agencyManagementTable.getAllAgencies();
    },
    // Emits from table
    onTableElementsCountChange(value) {
      this.tableElementCount = value;
    },
    onAgencySelected(agency) {
      this.selectedAgency = agency;
      this.agencySelected = Object.keys(agency).length === 0 ? false : true;
    },
    onAgencyOpenEdit(agency) {
      this.selectedAgency = agency;
      this.toggleModal(false);
    },
    // Emits from edit modal
    onModalClosed() {
      this.showEditModal = false;
    },
    onAgencyDeleted() {
      $.ajax({
        method: "DELETE",
        url: `api/agencies/${this.selectedAgency.AgencyGuid}`,
        success: () => {
          this.showDeleteModal = false;
          this.onAgencySelected({});
          this.$refs.agencyManagementTable.getAllAgencies();
          this.globals.showSuccessSnackbar("Agency deletion successful");
        },
        error: (error) => {
          console.error(`Error deleting agency`, error);
          this.globals.showErrorSnackbar("Agency deletion failed");
        },
      });
    },
    onAgencySaved(newAgency) {
      let request = {
        method: "POST",
        url: "api/agencies",
        data: JSON.stringify(newAgency),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.selectedAgency = newAgency;
          if (data[0]) this.selectedAgency.AgencyGuid = data[0].AgencyGuid;
          this.$refs.agencyManagementTable.getAllAgencies();
          this.globals.showSuccessSnackbar("Agency data update successful");
        },
        error: () => {
          this.globals.showErrorSnackbar("Agency data update failed");
        },
      };

      if (!this.modeAdd) {
        request.method = "PUT";
        request.url += "/" + newAgency.AgencyGuid;
      }

      $.ajax(request);
    },
    onRefreshEnabled(value) {
      this.refreshEnabled = value;
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.triggerReload();
    },
  },
  components: {
    AgencyManagementToolbar,
    AgencyManagementTable,
    AgencyManagementEditModal,
    ConfirmationDialog,
  },
};
</script>



// WEBPACK FOOTER //
// AgencyManagement.vue?1417ce6e